import { sharedSmtpRelayDe, sharedSmtpRelayEn } from "./smtpRelayTranslations";
import { sharedSmtpDeliveryModeDe, sharedSmtpDeliveryModeEn } from "../access-email/smtpDeliveryModeTranslations";

export const smtpEmailAccountDe = { ...sharedSmtpRelayDe, ...sharedSmtpDeliveryModeDe,
  "EmailAccount.smtp": "Postausgang (SMTP)",
  "EmailAccount.secretConfigured": "Passwort hinterlegt", "EmailAccount.replaceSecret": "ersetzen",
  "EmailAccount.showSecret": "anzeigen", "EmailAccount.hideSecret": "verbergen",
} as const;
export const smtpEmailAccountEn = { ...sharedSmtpRelayEn, ...sharedSmtpDeliveryModeEn,
  "EmailAccount.smtp": "Outgoing (SMTP)",
  "EmailAccount.secretConfigured": "Password stored", "EmailAccount.replaceSecret": "replace",
  "EmailAccount.showSecret": "show", "EmailAccount.hideSecret": "hide",
} as const;
